import React from "react";

import { MarketplaceLaunchableCardWrapper } from "./marketplace-launchable-card";

interface FeaturedSectionProps {
  launchableIds: string[];
}

export function FeaturedSection({ launchableIds }: FeaturedSectionProps) {
  return (
    <section>
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <h2 className="text-xl font-bold text-primary">Featured</h2>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {launchableIds.map((launchableId, index) => (
          <MarketplaceLaunchableCardWrapper
            key={launchableId}
            environment={{ environment_id: launchableId }}
            topBadge={{
              text: `Featured`,
              variant: "info",
            }}
          />
        ))}
      </div>
    </section>
  );
}
